import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: [],
    userDataOptions: [],
    promotionOptions: []
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view,
    userDataOptions (state) {
      return state.userDataOptions.map(entry => {
        return {
          value: entry['@id'],
          text: entry.firmname1 ? entry.firmname1 : entry.fullName
        }
      })
    },
    promotionOptions (state) {
      return state.promotionOptions.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    }
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    },
    setUserDataOptions (state, payload) {
      state.userDataOptions = payload
    },
    setPromotionsOptions (state, payload) {
      state.promotionOptions = payload
    }
  },
  actions: {
    async getItems ({ commit }, url = 'e_x_s_b_price_user_datas') {
      commit('toggleLoading')
      const response = await new ApiService(url).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('toggleLoading')
    },
    async fetchUserDataOptions ({ commit }, url = 'user_datas/list') {
      let params = { pagination: false, isContractor: 1 }
      const response = await new ApiService(url, params).getResults()
      commit('setUserDataOptions', response.items)
    },
    async fetchPromotions ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_a_b_promotions', baseParams).getResults()
      commit('setPromotionsOptions', await response.items)
    }
  }
}
